import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDatePicker = styled(Box)(({ theme }) => ({
  width: "100%",
  borderRadius: theme.spacing(2),
  "& .react-datepicker-wrapper": {
    display: "block",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    fontSize: "10px",
    height: "40px",
    "& input": {
      padding: "5px",
    },
  },
  "& input": {
    height: "45px", // Match TextField height
    width: "100%",
    maxWidth: "600px",
    padding: "0 12px",
    border: "1px solid #ccc",
    borderRadius: 2,
    fontSize: "16px",
    boxSizing: "border-box",
  },
}));
